import { doReportError } from './report-error';
import { setErrorState } from './error-state';

export default {
  doReportError,
  setErrorState,
};
